import { drop } from "lodash";

export class MainHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.loadEventHandlers();
        this.checkWorklistPage();
        this.positionRatingDialog();
    }

    checkWorklistPage() {
        const worklist = document.body.querySelector("work-list");
        if (!worklist) {
            // remove header menu item to add new case without images
            const newCaseNoImagesLink = this.querySelector("a.new-case-no-images");
            if (newCaseNoImagesLink) {
                const liElement = newCaseNoImagesLink.closest("li.nav-item");
                liElement.remove();
            }
        }
    }

    positionRatingDialog() {
        const ratingDlg = this.querySelector(".page-rating-dlg");
        if (ratingDlg) {
            document.body.appendChild(ratingDlg);
            ratingDlg.style.left = window.innerWidth / 2 - ratingDlg.offsetWidth / 2 + "px";
            ratingDlg.style.top = window.innerHeight / 2 - ratingDlg.offsetHeight / 2 + "px";
        }
    }

    loadEventHandlers() {
        const navToggles = this.querySelectorAll("a.nav-top-item");
        navToggles.forEach((elem) => {
            elem.addEventListener("mouseover", this.toggleMenu.bind(this));

            elem.addEventListener("mouseleave", this.mouseLeaveMenu.bind(this));
            const parent = elem.closest("li.nav-top");
            const navDropdownList = parent.querySelector("ul.nav-dropdown-list");
            if (navDropdownList) {
                parent.addEventListener("mouseleave", this.mouseLeaveMenu);
            }
        });

        const sideToggles = this.querySelectorAll("a.side-toggle");
        sideToggles.forEach((elem) => {
            elem.addEventListener("mouseover", this.toggleSideMenu.bind(this));
            
            elem.addEventListener("mouseLeave", this.mouseLeaveSideMenu.bind(this));
            const sideParent = elem.closest("li.nav-side-item");
            const sideNavDropdownList = sideParent.querySelector("ul.nav-dropdown-sublist");
            if (sideNavDropdownList) {
                sideParent.addEventListener("mouseleave", this.mouseLeaveSideMenu.bind(this));
            }
        });

        const caseNoImagesLink = this.querySelector("a.new-case-no-images");
        if (caseNoImagesLink) {
            caseNoImagesLink.addEventListener("click", (event) => {
                event.preventDefault();
                this.renderNewCaseNoImages();
            });
        }

        document.body.querySelector(".newCaseNotFound")?.addEventListener("click", (event) => {
            event.preventDefault();
            const patient = event.target.dataset.patient;
            if (patient) {
                this.createCaseFromData(patient.ClinicPatientID, patient);
            }
        });

        const languageSelector = this.querySelector("li.nav-item-language");
        if (languageSelector) {
            languageSelector.addEventListener("mouseover", this.toggleLanguageList.bind(this));
            languageSelector.addEventListener("mouseleave", this.mouseLeaveLangList.bind(this));
            const langList = languageSelector.querySelector("ul.lang_ul");
            if (langList) {
                langList.addEventListener("mouseleave", this.mouseLeaveLangList.bind(this));
            }
            
        }

        const pageRating = this.querySelector(".nav-item-page-rating");
        if (pageRating) {
            pageRating.addEventListener("click", this.togglePageRating.bind(this));
        }

        const ratingDlg = document.body.querySelector(".page-rating-dlg");
        if (ratingDlg) {
            ratingDlg.addEventListener("click", (event) => {
                if (event.target === ratingDlg || event.target.classList.contains("close")) {
                    ratingDlg.close();
                }
            });
        }

    }


    toggleMenu(event) {
        const target = event.target;
        const parent = target.closest("li.nav-top");
        const dropdownList = parent.querySelector("ul.nav-dropdown-list");
        if (dropdownList && !dropdownList.classList.contains("show")) {
            dropdownList.style["display"] = "flex";
            dropdownList.classList.add("show");
            dropdownList.style["z-index"] = 100002;
        }
    }

    toggleSideMenu(event)
    {
        const target = event.target;
        const sideParent = target.closest("li.nav-side-item");
        const sideNavDropdownList = sideParent.querySelector("ul.nav-dropdown-sublist");
        if (sideNavDropdownList && !sideNavDropdownList.classList.contains("show")) {
            sideNavDropdownList.classList.add("show");
            sideNavDropdownList.style["z-index"] = 100002;
            sideNavDropdownList.style["display"] = "flex";
        }
    }



    toggleLanguageList(event) {
        event.preventDefault();
        const languageSelector = event.currentTarget;
        const langList = languageSelector.querySelector("ul.lang_ul");
        if (langList && !langList.classList.contains("show")) {
            langList.classList.add("show");
        }
    }

    togglePageRating(event) {
        event.preventDefault();
        const ratingDlg = document.body.querySelector(".page-rating-dlg");
        if (ratingDlg) {
            if (ratingDlg.hasAttribute("open")) {
                ratingDlg.close();
                ratingDlg.style.display = "none";
            } else {
                ratingDlg.style.display = "flex";
                ratingDlg.showModal();
            }
        }
    }

    mouseLeaveMenu(event) {
        const target = event.target;
        const parent = target.closest("li.nav-top");
        setTimeout(() => {
            const dropdownList = parent.querySelector("ul.nav-dropdown-list");
            if (!parent.matches(":hover")) {
                if (dropdownList) {
                    dropdownList.classList.remove("show");
                    dropdownList.style["z-index"] = -1;
                    dropdownList.addEventListener("transitionend", function transitionEndHandler() {
                        dropdownList.removeEventListener("transitionend", transitionEndHandler);
                    });
                }
            }
        }, 300);
    }

    mouseLeaveSideMenu(event)
    {
        const target = event.target;
        const sideParent = target.closest("li.nav-side-item");
        setTimeout(() => {
            if (!sideParent.matches(":hover")) {
                const sideNavDropdownList = sideParent.querySelector("ul.nav-dropdown-sublist");
                if (sideNavDropdownList) {
                    sideNavDropdownList.classList.remove("show");
                    sideNavDropdownList.style["z-index"] = -1;
                    sideNavDropdownList.addEventListener("transitionend", function transitionEndHandler() {
                        sideNavDropdownList.removeEventListener("transitionend", transitionEndHandler);
                    });
                }
            }
        }, 300);
    }

    mouseLeaveLangList(event) {
        setTimeout(() => {
            const langList = this.querySelector("ul.lang_ul");
            const parent = langList.closest("li.nav-item-language");
            if (!parent.matches(":hover")) {
                if (langList) {
                    langList.classList.remove("show");
                    langList.addEventListener("transitionend", function transitionEndHandler() {
                        langList.removeEventListener("transitionend", transitionEndHandler);
                        langList.style["z-index"] = 0;
                    });
                }
            }
        }, 300);
    }

    renderNewCaseNoImages() {
        let html = "Please enter the below details";
        html += '<div class="col-xs-12">';
        html += '<div class="form-group">';
        html +=
            '<input name="ClinicPatientID" data-manualac="true" class="form-control" type="text" data-method="newCaseSelect" data-widget="Worklist" placeholder="Clinic Patient ID">';
        html += "</div>";
        html += '<div class="form-group">';
        html +=
            '<input name="FirstName" data-manualac="true" class="form-control" type="text" placeholder="Patient Name">';
        html += "</div>";
        html += '<div class="form-group">';
        html +=
            '<input name="LastName" data-manualac="true" class="form-control" type="text" placeholder="Patient Lastname">';
        html += "</div>";
        html += '<div class="complete_area"></div>';
        html += '<div class="errors_area"></div>';
        html += "</div>";
        $("body").Vetology(
            "vetologyShowDialog",
            "Case Submit:",
            html,
            "info",
            function (data, modal) {
                $(".errors_area").html("").removeClass("alert alert-danger");
                var patientData = {};
                var form_data = data.split("&");
                $.each(form_data, function (key, value) {
                    value = value.split("=");
                    patientData[value[0]] = decodeURIComponent(value[1]);
                });
                var valid = false;
                $.each(patientData, function (i, e) {
                    if (!valid) {
                        valid = e.trim().length > 0;
                    }
                });
                $("body").AutoComplete(
                    "findPatients",
                    $('[name="ClinicPatientID"][data-manualac="true"]'),
                    patientData.ClinicPatientID,
                    patientData.FirstName,
                    patientData.LastName
                );
            },
            "Cancel, I will submit later",
            "Create case"
        );
    }

    newCaseSelect(patient) {
        var o = this;
        if (typeof patient === "string" || typeof patient === "number") {
            /*create case immediately*/
            $('[data-filter="FirstName"]').val($('[name="FirstName"][data-manualac="true"]').val());
            $('[data-filter="LastName"]').val($('[name="LastName"][data-manualac="true"]').val());
            o.createCaseFromData(patient);
        } else {
            /*work with it*/
            $('[data-filter="FirstName"]').val(patient.FirstName);
            $('[data-filter="LastName"]').val(patient.LastName);
            $('[data-filter="CaseID"]').val("");
            $('[data-filter="ClinicID"]').val(patient.clinic.ClinicID);
            $("body").addClass("filteringRecords");
            $('[data-filter="clinic_id"]').val(patient.clinic.ClinicID).change();
            $('[data-filter="perpage"]').val(2);
            $("body").Filters("getRecords");
            var i = setInterval(function () {
                if (!$("body").hasClass("filteringRecords")) {
                    clearInterval(i);
                    if ($(".box-case").length > 1) {
                        /*More records were found*/
                        $(".newCaseNotFound").remove();
                        $(".newCaseNoImages").after(
                            '<button data-patient="" class="vetology_pd btn btn-warning btn-block btn-flat newCaseNotFound">My case is not on the list</button>'
                        );
                        $(".newCaseNotFound").data("patient", patient);
                        $("body").Vetology(
                            "vetologyShowDialog",
                            "Case Submit:",
                            'Please select the case you like to submit from the list.<br>If your case is not on the list, click on the "My case is not on the list button"',
                            "info",
                            null,
                            "Close"
                        );
                        $(".newCaseNotFound").on("click", function (event) {
                            event.preventDefault();
                            o.createCaseFromData(patient.clinic.ClinicID, patient);
                        });
                    }
                }
            }, 100);
        }
    }

    createCaseFromData(patient_id, patient) {
        var data = {
            id: typeof patient !== "undefined" ? patient.PatientID : 0,
            patientName: $('input[name="FirstName"]').val(),
            patientLastName: $('input[name="LastName"]').val(),
            clinicid: patient_id,
        };
        $("body").Vetology(
            "doRequest",
            "POST",
            data,
            "/create-case-no-images",
            function (json) {
                $(".newCaseNotFound").remove();
                $('[data-filter="case_id"]').val(json.case);
                $('[data-filter="first_name"]').val("");
                $('[data-filter="last_name"]').val("");
                $('[data-filter="clinic_id"]').val("");
                $('[data-filter="is_stat"]').val("");
                $('[data-filter="modality"]').val("");
                $('[data-filter="species_id"]').val("").change();
                setTimeout(function () {
                    $("body").Vetology(
                        "vetologyShowDialog",
                        "Success:",
                        "A new case with ID " +
                            json.case +
                            " has been created and is listed, when you are ready to submit it for review click on the submit button.",
                        "success"
                    );
                    $(".isFilter").change();
                }, 1000);
            },
            "JSON"
        );
    }

}

customElements.define('main-header', MainHeader);